import { isEqual } from "date-fns"
import moment from "moment"

// Base date range filter using moment
export const dateFilterFn = (row, columnId, filterValue) => {
  let rowValue = moment(row.getValue(columnId))
  if (!rowValue.isValid())
    return false // do not add to filtered rows

  const [start, end] = filterValue

  if (start && end)
    return rowValue.isBetween(start, end, 'day', '[]')
  else if (start)
    return rowValue.isSameOrAfter(start, 'day')
  else if (end)
    return rowValue.isSameOrBefore(end, 'day')

  return true // add to filtered rows
}

// Date range filter using date-fns
export const dateRangeFilter = (row, columnId, { startDate, endDate }) => dateFilterFn(
  row, columnId,
  [startDate, isEqual(startDate, endDate) ? null : endDate]
)


export const globalFilterFn = (rowInstance, columnName, filterValue) => {
  let rowData = rowInstance.original
  console.log('filtering', rowInstance, columnName, filterValue)

  if (rowData.hasOwnProperty(columnName))
    rowData = rowData[columnName]

  return (rowData + '').toLowerCase().includes(filterValue.toLowerCase())
}